module.exports = __webpack_public_path__ + "static/media/user.1578e09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user.png
// module id = 1227
// module chunks = 8